import { render, staticRenderFns } from "./Almacenes.vue?vue&type=template&id=48fad91d&scoped=true"
import script from "./Almacenes.vue?vue&type=script&lang=js"
export * from "./Almacenes.vue?vue&type=script&lang=js"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./Almacenes.vue?vue&type=style&index=1&id=48fad91d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fad91d",
  null
  
)

export default component.exports